import * as React from "react";
import { Button } from "./Button";

export class DragAndDropButton extends Button {

	render() {
		return <Button {...this.props}>
			<i>
				<svg version="1.1" id="Sample" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="32,16 25,9 25,14 18,14 18,7 23,7 16,0 9,7 14,7 14,14 7,14 7,9 0,16 7,23 7,18 14,18 14,25 9,25 16,32 23,25 18,25 18,18 25,18 25,23" />
				</svg>
			</i>
		</Button>;
	}
}
